exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.auth-form{margin-top:120px!important\n}", ""]);

// exports
